/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useState } from "react";
import { getLogisticByIdApi } from "../../services/_logistic";

interface Props {
  logisticId: string;
}

const ViewLogistic: React.FC<Props> = ({ logisticId }) => {
  const [logistic, setLogistic] = useState<any>({});

  useEffect(() => {
    if (logisticId) {
      setLogistic({});
      getSupplierDetails();
    }
  }, [logisticId]);

  const getSupplierDetails = async () => {
    const result: any = await getLogisticByIdApi(logisticId as string);
    if (result.isSuccess) {
      setLogistic(result?.data);
    }
  };

  return (
    <div
      className="modal fade"
      id="viewProduct"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-simple modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body pt-0 pb-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="text-center">
              <h4 className="mb-0">Forwarder Details</h4>
            </div>
            <div className="info-container">
              <div className="pb-4 border-bottom text-capitalize mb-4"></div>
              <ul className="list-unstyled mb-6">
                <li className="mb-2">
                  <span className="h6 me-1">Name:</span>
                  <span>{logistic?.name}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Email:</span>
                  <span>{logistic?.email}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Phone No:</span>
                  <span>{logistic?.phone_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">PAN No:</span>
                  <span>{logistic?.pan_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">GST No:</span>
                  <span>{logistic?.gst_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">TAN No:</span>
                  <span>{logistic?.tan_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">UDHYAM No:</span>
                  <span>{logistic?.udhyam_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Address:</span>
                  <span>{logistic?.address}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">City:</span>
                  <span>{logistic?.city}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">State:</span>
                  <span>{logistic?.state}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">State Code:</span>
                  <span>{logistic?.state_code}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Country:</span>
                  <span>{logistic?.country}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Pin Code:</span>
                  <span>{logistic?.pin_code}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Status:</span>
                  <span
                    className={`badge ${
                      logistic?.status ? "bg-label-success" : "bg-label-danger"
                    }`}
                  >
                    {logistic?.status ? "Active" : "Inactive"}
                  </span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Created At:</span>
                  <span>
                    {logistic?.created_at
                      ? moment(logistic?.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewLogistic;
